/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { stopProgress } from './progress-util.js';

import { showSnackbar } from './snackbar.js';



function default_ajax_error_handler( jqXHR, textStatus, message ) {
	stopProgress();
	if( textStatus=='timeout' ) {
		showSnackbar('AJAX timeout');
	} else if( textStatus=='error' ) {
		default_ajax_error_handler_error(jqXHR,message);
	} else if( textStatus=='notmodified' ) {
		//showSnackbar('AJAX cache hit');
	} else if( textStatus=='parseerror' || textStatus=='parsererror' ) {
		if( jqXHR.responseText ) showSnackbar('AJAX error response: '+jqXHR.responseText);
		else showSnackbar('AJAX error parsing response');
	} else if( textStatus=='abort' ) {
		/* do not show message */
	} else {
		showSnackbar('AJAX: unknown error ('+textStatus+': '+jqXHR.status+')' + (message?' - '+message:''));
	}
}

function default_ajax_error_handler_error( jqXHR, message ) {
	if( jqXHR.status==414 ) {
		showSnackbar('Fehler! Konnte die Anfrage nicht ausführen. Bitte Auswahl verkleinern.'); // Request-URI too large..
		return;
	}
	var r = jqXHR.responseJSON;
	if( r && r.logout ) {
		mj_handle_invalid_session(r);
	} else if( r && r.error ) {
		if( jqXHR.status==500 && message=='Internal Server Error' ) {
			// HTTP 500 "Internal Server Error" is too general ...
			// -> we already know that we have details in r.error
			// -> remove HTTP message
			message = '';
		}
		if( r.message ) message = r.message;
		default_ajax_app_error_handler(r.error+(message?' - '+message:''),r);
	} else if( jqXHR.status!==0 || typeof r !== 'undefined' ) {
		showSnackbar('AJAX error ('+jqXHR.status+')'+(message?' - '+message:''));
	}
	// NOTE: status===0 && typeof r === 'undefined' usually is the case when a request was aborted - dont show that in UI
}

function default_ajax_app_error_handler( server_msg, r ) {
	stopProgress();
	if( r && r.error_details ) {
		try {
			var d = JSON.parse(r.error_details);
			if( d.logout ) return mj_handle_invalid_session(r);
		} catch( err ) {
			// empty
		}
	}
	showSnackbar('AJAX error response: '+server_msg);
}

function intercept_ajax_backend_errors( jqXHR, textStatus, ajaxSettings ) {
	if( mj.backend_exception_hook && textStatus==='error' ) {
		var r = jqXHR.responseJSON;
		if( r && r.error && r.error_is_backend_exception ) {
			mj.backend_exception_hook(r,ajaxSettings.type,ajaxSettings.url,ajaxSettings.data);
		}
	}
}

function mj_handle_invalid_session( resp ) {
	// TODO: provide better feedback to user
	var e = resp.error;
	var 												txt = mjt('err-mjUserAuthenticationRequiredError');
	if( e==='mjSessionGoneError' )						txt = mjt('err-mjSessionGoneError');
	else if( e==='mjHigherPermissionsExpectedError' )	txt = mjt('err-mjHigherPermissionsExpectedError');
	else if( e==='mjFunctionNotAvailableError' )		txt = mjt('err-mjFunctionNotAvailableError');
	if( resp.message ) txt += ': '+resp.message;
	showSnackbar(txt);
	var req = '?error='+encodeURIComponent(e)
			+ '&message='+encodeURIComponent(resp.message||'')
			+ '&error_details='+encodeURIComponent(resp.error_details||'');
	setTimeout( function() {
		document.location.replace(mj.uwn+'/init'+req);
	}, 3000 );
}








function initManjaBackendFetch() {
	// ajax config
	jQuery.ajaxSetup( {
		cache: false,
		scriptCharset: 'UTF-8',
		timeout: 30*60*1000,
		error: default_ajax_error_handler,
		beforeSend: function( xhr, settings ) {
			if( window.mj.csrf_token && !settings.crossDomain && ( settings.type=='POST' || settings.type=='PUT' || settings.type=='DELETE' ) ) {
				xhr.setRequestHeader('X-CSRF-Token',window.mj.csrf_token);
			}
			// apply base url ...
			var u = settings.url;
			if( u.length > 1 && u.startsWith('json/') ) {
				settings.url = (mj.webroot||'/') + u;
			}
		},
	} );
}



function postToBackend( url, data, success_callback, default_handle_errors, complete_callback ) {
	return postToBackend2(url,data,success_callback,null,default_ajax_error_handler,default_handle_errors,complete_callback);
}

function postToBackend2( url, data, success_callback, timeout_callback, error_callback, default_handle_errors, complete_callback ) {
	var settings = {
		method: 'POST',
		url: url,
		data: data,
		dataType: 'json',
		success: function _mj_postJSON2_success( r, textStatus, jqXHR ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( r && r.logout ) return mj_handle_invalid_session(r);
			if( default_handle_errors && r && r.hasOwnProperty('error') && r.error!==false ) return default_ajax_app_error_handler(r.error,r);
			if( success_callback ) return success_callback(r,jqXHR);
		},
		error: function _mj_postJSON2_error( jqXHR, textStatus, message ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( textStatus==='timeout' && timeout_callback ) return timeout_callback();
			if( error_callback ) return error_callback(jqXHR,textStatus,message);
			return default_ajax_error_handler(jqXHR,textStatus,message);
		},
	};
	if( complete_callback ) {
		settings.complete = function _mj_postJSON2_complete( jqXHR, textStatus ) {
			complete_callback(jqXHR,textStatus,this);
		};
	}
	return jQuery.ajax(settings);
}

function getFromBackend( url, data, cache, success_callback, timeout_callback, error_callback, default_handle_errors ) {
	// add our cache-tag to urls (varies by release, so after a manja update, users caches are invalidated ..)
	url += (url.indexOf('?')===-1?'?':'&')+mj.cutag0;
	//if( !mj.minify ) url += '&minify=off';
	return jQuery.ajax( {
		method: 'GET',
		url: url,
		data: data,
		dataType: 'json',
		cache: !!cache,
		success: function _mj_getJSON2_success( r, textStatus, jqXHR ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( r && r.logout ) return mj_handle_invalid_session(r);
			if( default_handle_errors && r && r.hasOwnProperty('error') && r.error!==false ) return default_ajax_app_error_handler(r.error,r);
			if( success_callback ) return success_callback(r,jqXHR);
		},
		error: function _mj_getJSON2_error( jqXHR, textStatus, message ) {
			intercept_ajax_backend_errors(jqXHR,textStatus,this);
			if( textStatus=='timeout' && timeout_callback ) return timeout_callback();
			if( error_callback ) return error_callback(jqXHR,textStatus,message);
			return default_ajax_error_handler(jqXHR,textStatus,message);
		},
	} );
}


function getCachedScript( url, options ) {
	return jQuery.ajax(jQuery.extend(options||{},{dataType:'script',cache:true,url:url}));
}



export {
	default_ajax_error_handler,
	default_ajax_error_handler_error,
	default_ajax_app_error_handler,
	mj_handle_invalid_session,
	intercept_ajax_backend_errors,

	initManjaBackendFetch,

	postToBackend,
	postToBackend2,
	getFromBackend,
	getCachedScript,
};

